module.exports = __webpack_public_path__ + "static/media/IMG_0775.2a78a56e.jpg";